// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    font: 14px "Century Gothic", Futura, sans-serif;
    margin: 20px;
  }
  
  ol, ul {
    padding-left: 30px;
  }
  
  .board-row:after {
    clear: both;
    content: "";
    display: table;
  }
  
  .status {
    margin-bottom: 10px;
  }
  
  .square {
    background: #fff;
    border: 1px solid #999;
    float: left;
    font-size: 24px;
    font-weight: bold;
    line-height: 34px;
    height: 34px;
    margin-right: -1px;
    margin-top: -1px;
    padding: 0;
    text-align: center;
    width: 34px;
  }
  
  .square:focus {
    outline: none;
  }
  
  .kbd-navigation .square:focus {
    background: #ddd;
  }
  
  .game {
    display: flex;
    flex-direction: row;
  }
  
  .game-info {
    margin-left: 20px;
  }
   */

  /*
 * Globals
 */

/* Links */
a,
a:focus,
a:hover {
  color: #fff;
}

/* Custom default button */
.btn-secondary,
.btn-secondary:hover,
.btn-secondary:focus {
  color: #333;
  text-shadow: none; /* Prevent inheritance from \`body\` */
  background-color: #fff;
  border: .05rem solid #fff;
}


/*
 * Base structure
 */

html,
body {
  height: 100%;
  /* background-color: #a6348a; */
  background-color: #333;
}

body {
  display: flex;
  color: #fff;
  text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5);
  box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);
}

.cover-container {
  max-width: 42em;
}


/*
 * Header
 */
.masthead {
  margin-bottom: 2rem;
}

.masthead-brand {
  margin-bottom: 0;
}

.nav-masthead .nav-link {
  padding: .25rem 0;
  font-weight: 700;
  color: rgba(255, 255, 255, .5);
  background-color: transparent;
  border-bottom: .25rem solid transparent;
}

.nav-masthead .nav-link:hover,
.nav-masthead .nav-link:focus {
  border-bottom-color: rgba(255, 255, 255, .25);
}

.nav-masthead .nav-link + .nav-link {
  margin-left: 1rem;
}

.nav-masthead .active {
  color: #fff;
  border-bottom-color: #fff;
}

@media (min-width: 48em) {
  .masthead-brand {
    float: left;
  }
  .nav-masthead {
    float: right;
  }
}


/*
 * Cover
 */
.cover {
  padding: 0 1.5rem;
}
.cover .btn-lg {
  padding: .75rem 1.25rem;
  font-weight: 700;
}


/*
 * Footer
 */
.mastfoot {
  color: rgba(255, 255, 255, .5);
}


.musicButton {
  width: 200px;
  margin-right: 10px;
  margin-left: 10px;
}

.connect {
  text-align: center;
}
.gameboy {
  max-width: 75px;
  object-fit: contain;
}

.username-input {
  background-color: rgb(65, 65, 65);
  color: white;
  font-weight: 700;
  border-color: gray;
  text-align: center;
  width: 300pt;
  display: inline;
}

.game-code-input {
  background-color: rgb(65, 65, 65);
  color: white;
  font-weight: 700;
  border-color: gray;
  text-align: center;
  display: inline;
  margin-bottom: 20px;
}

.custom-card {
  background-color: #444;
  height: 194px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAkDI;;EAEF;;EAEA;;AAEF,UAAU;AACV;;;EAGE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;;;EAGE,WAAW;EACX,iBAAiB,EAAE,oCAAoC;EACvD,sBAAsB;EACtB,yBAAyB;AAC3B;;;AAGA;;EAEE;;AAEF;;EAEE,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EAEE,aAAa;EACb,WAAW;EACX,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;;AAGA;;EAEE;AACF;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;;;AAGA;;EAEE;AACF;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA;;EAEE;AACF;EACE,8BAA8B;AAChC;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf","sourcesContent":["/* body {\n    font: 14px \"Century Gothic\", Futura, sans-serif;\n    margin: 20px;\n  }\n  \n  ol, ul {\n    padding-left: 30px;\n  }\n  \n  .board-row:after {\n    clear: both;\n    content: \"\";\n    display: table;\n  }\n  \n  .status {\n    margin-bottom: 10px;\n  }\n  \n  .square {\n    background: #fff;\n    border: 1px solid #999;\n    float: left;\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 34px;\n    height: 34px;\n    margin-right: -1px;\n    margin-top: -1px;\n    padding: 0;\n    text-align: center;\n    width: 34px;\n  }\n  \n  .square:focus {\n    outline: none;\n  }\n  \n  .kbd-navigation .square:focus {\n    background: #ddd;\n  }\n  \n  .game {\n    display: flex;\n    flex-direction: row;\n  }\n  \n  .game-info {\n    margin-left: 20px;\n  }\n   */\n\n  /*\n * Globals\n */\n\n/* Links */\na,\na:focus,\na:hover {\n  color: #fff;\n}\n\n/* Custom default button */\n.btn-secondary,\n.btn-secondary:hover,\n.btn-secondary:focus {\n  color: #333;\n  text-shadow: none; /* Prevent inheritance from `body` */\n  background-color: #fff;\n  border: .05rem solid #fff;\n}\n\n\n/*\n * Base structure\n */\n\nhtml,\nbody {\n  height: 100%;\n  /* background-color: #a6348a; */\n  background-color: #333;\n}\n\nbody {\n  display: -ms-flexbox;\n  display: flex;\n  color: #fff;\n  text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5);\n  box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5);\n}\n\n.cover-container {\n  max-width: 42em;\n}\n\n\n/*\n * Header\n */\n.masthead {\n  margin-bottom: 2rem;\n}\n\n.masthead-brand {\n  margin-bottom: 0;\n}\n\n.nav-masthead .nav-link {\n  padding: .25rem 0;\n  font-weight: 700;\n  color: rgba(255, 255, 255, .5);\n  background-color: transparent;\n  border-bottom: .25rem solid transparent;\n}\n\n.nav-masthead .nav-link:hover,\n.nav-masthead .nav-link:focus {\n  border-bottom-color: rgba(255, 255, 255, .25);\n}\n\n.nav-masthead .nav-link + .nav-link {\n  margin-left: 1rem;\n}\n\n.nav-masthead .active {\n  color: #fff;\n  border-bottom-color: #fff;\n}\n\n@media (min-width: 48em) {\n  .masthead-brand {\n    float: left;\n  }\n  .nav-masthead {\n    float: right;\n  }\n}\n\n\n/*\n * Cover\n */\n.cover {\n  padding: 0 1.5rem;\n}\n.cover .btn-lg {\n  padding: .75rem 1.25rem;\n  font-weight: 700;\n}\n\n\n/*\n * Footer\n */\n.mastfoot {\n  color: rgba(255, 255, 255, .5);\n}\n\n\n.musicButton {\n  width: 200px;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.connect {\n  text-align: center;\n}\n.gameboy {\n  max-width: 75px;\n  object-fit: contain;\n}\n\n.username-input {\n  background-color: rgb(65, 65, 65);\n  color: white;\n  font-weight: 700;\n  border-color: gray;\n  text-align: center;\n  width: 300pt;\n  display: inline;\n}\n\n.game-code-input {\n  background-color: rgb(65, 65, 65);\n  color: white;\n  font-weight: 700;\n  border-color: gray;\n  text-align: center;\n  display: inline;\n  margin-bottom: 20px;\n}\n\n.custom-card {\n  background-color: #444;\n  height: 194px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
